import React from 'react';
import {useIntl} from 'react-intl';

import messages from '../../messages';

import {IFiltersRefinementCountProps} from './IFiltersRefinementCount';

import styles from './FiltersRefinementCount.module.scss';

const FiltersRefinementCount = ({count}: IFiltersRefinementCountProps) => {
	const intl = useIntl();
	const totalSelected = count;

	if (!count) {
		return null;
	}

	return (
		<span className={styles['filters-refinement__count']} data-selected-count={totalSelected}>
			{intl.formatMessage(messages.selected, {totalSelected: totalSelected ? totalSelected : ''})}
		</span>
	);
};

export default FiltersRefinementCount;